import {h, Component} from 'preact'
import constants from '../constants'
import Spinner from './Spinner'
import Masonry from 'react-masonry-component';
import {connect} from "react-redux";
import reduce from "../reducers";
import * as actions from "../actions";

export default @connect(reduce, actions)
class AsideDesignAccents extends Component {
    constructor() {
        super()
        this.state = {
            accents:             [],
            isLoading:          false,
        }
    }

    componentWillMount () {
        this.findAccents()
    }

    findAccents () {
        this.setState({ isLoading: true, accents: [] })

        const accents = []

        const illustrations = this.props.accents.illustrations
        
        if (!this.props.isReplaceFrameMode) {
            illustrations.forEach(illustration => {
                accents.push(
                    <div className="component template" data-component="illustration">
                        <div className="image" data-component="illustration" data-id={illustration}>
                            <div className="img-wrap"><img style="width: 100%; height: 100%;" src={ constants.RENDERER_DOMAIN + '/illustration/thumbnail/' + illustration + '?width=200' } /></div>
                        </div>
                    </div>
                )
            })
        }

        const images = this.props.accents.images
        images.forEach(image => {
            accents.push(
                <div class="component template frame" data-component="frame">
                     <div class="frame" data-component="frame" data-type="frame">
                         <div class="img" data-original-bg-img={image.replace(constants.S3_PATH, constants.SECURE_S3_PATH)} style={`width: 100%; height: 100%;`}>
                             <picture>
                                 <img loading={'lazy'} style="width: 100%; height 100%;" class="img" src={image.replace(constants.S3_PATH, constants.SECURE_S3_PATH)}/>
                             </picture>
                         </div>
                     </div>
                 </div>)
        })

        this.setState({ isLoading: false, accents: accents })
    }

    goBack () {
        this.props.goToRoot()
    }

    handleError(accent, ev) {
        ev.target.src = accent;
    }

    onImagesLoaded() {
    }

    render (props, state) {
        const imageLoadingSpinner = state.isLoading ? <Spinner /> : null

        let content = null
        if (!state.isLoading) {
            content = (<Masonry updateOnEachImageLoad={true}
                                className={'masonry-grid'}
                                onImagesLoaded={this.onImagesLoaded}>
                                {state.accents}
                        </Masonry>)
        }

        return (
            <div id="app-aside-free-images" class="aside-text aside-design-accents">
                <div class="to-root">
                    <a onClick={ () => this.goBack() }>
                        All graphics
                    </a>
                    <span class="path">&gt;&nbsp; Design Accents</span>
                </div>
                <div class="scroller">
                    { imageLoadingSpinner }
                    <div class="components images">
                        { content }
                    </div>
                </div>
            </div>
        )
    }
}
